import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import BookIcon from "@mui/icons-material/Book";
import Loader from "../../Components/Loader";
import "../../Styles/DownloadNotes.css";

function StudentNotes() {
  const [pageLoading, setPageLoading] = useState(true);
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    const fetchNotes = async () => {
      const token = localStorage.getItem("authToken");
      try {
        const response = await axios.get(
          "https://api.uniums.com/api/notes/download-notes",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setNotes(response.data.notes);
      } catch (error) {
        console.error("Error fetching notes:", error);
        toast.error("Failed to fetch notes");
      } finally {
        setPageLoading(false);
      }
    };

    fetchNotes();
  }, []);
  const handleDownload = (fileUrl) => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank"; 
    link.rel = "noopener noreferrer";
    link.setAttribute("download", fileUrl.split("/").pop()); 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="download-notes-container">
      {pageLoading ? (
        <Loader />
      ) : (
        <>
          <h1>Shared Notes</h1>
          <p className="p-para">View study materials shared by others.</p>

          <div className="notes-list-download">
            {notes.length === 0 ? (
              <p>No notes available</p>
            ) : (
              <ul className="Notes-list-box-download">
                {notes.map((note) => (
                  <li key={note._id} className="note-card-download">
                    <div className="notes_items-download">
                      <span className="note-title-download">
                        <BookIcon className="note-icon" /> {note.title}
                      </span>
                      <p className="note-title-para-download note-title-p-download">
                        {note.description}
                      </p>
                      <p className="note-title-para-download">
                        <button
                          onClick={() => handleDownload(note.attachment)}
                          className="download-button"
                        >
                          <AttachFileIcon /> Download Document
                        </button>
                      </p>
                    </div>
                    <span className="note-title-time-download">
                      {new Date(note.uploadedAt).toLocaleDateString()}
                      &nbsp;&nbsp;
                      {new Date(note.uploadedAt).toLocaleTimeString()}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <ToastContainer />
        </>
      )}
    </div>
  );
}

export default StudentNotes;
